import { CITIES } from '@spa/shared/constants/locationTypes';
import { translationFromLocale } from '.';
import { languageToLocale } from '../language';

export const transformQuestionsAnswersAndRelatedLinks = (location, language) => {
  if (!location || !location.type) {
    return {};
  }

  const { type: locationType } = location;
  const { items: questionsAnswers } = location.questions_answers || { items: [] };
  const { items: relatedLinks } = location.related_links || { items: [] };
  const locale = languageToLocale(language);

  const locationName = translationFromLocale(location.metadata.name_translations.items, locale);
  const cityName =
    locationType === CITIES
      ? locationName
      : translationFromLocale(location.city.metadata.name_translations.items, locale);

  const formatedQuestionsAnswers = questionsAndAnswersFromCoreFormat(questionsAnswers, locale);
  const formatedRelatedlinks = relatedLinksFromCoreFormat(relatedLinks, locale);

  return { questionsAnswers: formatedQuestionsAnswers, relatedLinks: formatedRelatedlinks, cityName, locationName };
};

const relatedLinksFromCoreFormat = (relatedLinks, locale) => {
  return relatedLinks.reduce((acc, link) => {
    const {
      url,
      metadata: {
        title_translations: { items: titleTranslations },
        subtitle_translations
      }
    } = link;

    const title = translationFromLocale(titleTranslations, locale);
    const subtitle =
      subtitle_translations && subtitle_translations.items.length
        ? translationFromLocale(subtitle_translations.items, locale)
        : null;

    return [...acc, { url, title, subtitle }];
  }, []);
};

const questionsAndAnswersFromCoreFormat = (questionsAnswers, locale) => {
  return questionsAnswers.reduce((acc, questionAnswer) => {
    const {
      url,
      metadata: {
        question_translations: { items: questionTranslations },
        answer_translations: { items: answerTranslations }
      }
    } = questionAnswer;

    const question = translationFromLocale(questionTranslations, locale);
    const answer = translationFromLocale(answerTranslations, locale);

    return [...acc, { url, question, answer }];
  }, []);
};
